import {parseISO} from 'date-fns'
import {Space} from 'antd'

import styles from './LoanForm.module.scss'
import {
  Form,
  FormItem,
  InputAmount,
  InputPercent,
  RangePicker,
  Box,
  Button,
} from 'common/components'
import {useInputFocus} from 'common/hooks'
import {formatDate} from 'common/helpers'
import {FIELD_RULES, REQUEST_CURRENT_STATUSES} from 'common/constants'
import {useUpdateRequest} from '..'

interface LoanFormProps {
  request: any
  onClose: () => void
}

export default function LoanForm({request, onClose}: LoanFormProps) {
  const {mutate: updateRequest, isMutating} = useUpdateRequest(
    request.uuid,
    onClose
  )
  const disabledBonus = request?.status === REQUEST_CURRENT_STATUSES['LM check'];
  const isFcCheck = request?.status === REQUEST_CURRENT_STATUSES['FC check'];
  // const role = useStore((state) => state.role)
  const inputRef = useInputFocus()

  const handleFinish = ({bonus, dates, ...values}: any) => {
    const newValues = 
      // role.controller
      // ? {bonus}
      // : 
        {
          bonus,
          ...values,
          openDate: formatDate(dates[0], 'server'),
          maturityDate: formatDate(dates[1], 'server'),
          tagCheckType: isFcCheck ? 'BonusGranted' : ''
        }
    updateRequest(newValues)
  }

  const initialValues: any = {
    loanValue: request.loanValue || request.loanValueRequested,
    dates: [parseISO(request.openDate), parseISO(request.maturityDate)],
    lvrMax: request.lvrMax,
    interest: request.interest,
    establishFee: request.establishFee,
    lineFee: request.lineFee,
    irr: request.irr,
    bonus: request.bonus,
  }
  if (process.env.NODE_ENV === 'development') {
    initialValues.lvrMax      = initialValues.lvrMax        || 70;
    initialValues.interest    = initialValues.interest      || 7.99;
    initialValues.establishFee= initialValues.establishFee  || 3;
    initialValues.lineFee     = initialValues.lineFee       || 0.25;
    initialValues.irr         = initialValues.irr           || 9;
  }

  return (
    <Form initialValues={initialValues} onFinish={handleFinish}>
      <div className={styles.fieldset}>
        <FormItem name="loanValue" label="Loan amount, nzd" rules={FIELD_RULES}>
          <InputAmount
            ref={inputRef}
            disabled={false}
          />
        </FormItem>
        <FormItem
          name="dates"
          label="Loan open & maturity dates"
          rules={FIELD_RULES}
        >
          <RangePicker disablePast disabled={false} />
        </FormItem>
      </div>
      <Space size={12} className={styles.values}>
        <FormItem name="lvrMax" label="Loan max LVR" rules={percentFieldRules}>
          <InputPercent disabled={false} />
        </FormItem>
        <FormItem
          name="interest"
          label="Loan interest"
          rules={percentFieldRules}
        >
          <InputPercent disabled={false} />
        </FormItem>
        <FormItem
          name="establishFee"
          label="Estab. fee"
          rules={percentFieldRules}
        >
          <InputPercent disabled={false} />
        </FormItem>
        <FormItem
          name="lineFee"
          label="Line fee, monthly"
        >
          <InputPercent disabled={false} />
        </FormItem>
        <FormItem name="irr" label="Loan IRR" rules={percentFieldRules}>
          <InputPercent disabled={false} />
        </FormItem>
        <FormItem
          name="bonus"
          label="Bonus"
          rules={undefined}
        >
          <InputPercent disabled={disabledBonus} />
        </FormItem>
      </Space>
      <Box align="center" mt={12}>
        <Button htmlType="submit" loading={isMutating}>
          Save
        </Button>
      </Box>
    </Form>
  )
}

const percentFieldRules = [
  ...FIELD_RULES,
  () => ({
    validator(_: any, value: any) {
      if (value) {
        return Promise.resolve()
      }
      return Promise.reject()
    },
  }),
]